/**
 * 拼合图像（DESIGN.md §7.1 补充：「图层→拼合图像」/图层面板右键，
 * 参照 Photoshop）。
 *
 * 已知简化：**始终保留透明度**。真实 PS 在文档有"背景图层"时，拼合会把
 * 透明区域填成当前背景色；这个编辑器没有"背景图层"这个标记概念，
 * 拼合结果原样保留 alpha——跟这里一贯"没有背景图层概念"的既有简化
 * 一致，不是这次新引入的差异。
 */
import { layerDefaults } from '../document/draft';
import type { RasterLayer } from '../document/types';
import { layerId } from '../engine/tile/key';
import { compositeDocument } from './composite';
import { writeImageIntoTiles } from './rasterize';
import { createFlattenImageCommand } from './commands/layer-commands';
import type { AppStore } from './store';

/**
 * 把全部图层压平成一张，删掉其余。返回是否真的执行了——没有文档、或者
 * 已经是单一像素图层（拼合是空操作）时 false，不留一条什么都没变的历史。
 */
export function flattenImage(store: AppStore, nextLayerId: () => string): boolean {
  const document = store.document;
  if (document === null || document.root.children.length === 0) return false;
  if (document.root.children.length === 1 && document.root.children[0]!.kind === 'raster') {
    return false;
  }

  const composite = compositeDocument(document, store.tiles);
  const id = layerId(nextLayerId());
  const transaction = store.beginPixelTransaction('拼合图像');
  const bounds = writeImageIntoTiles(store, id, composite, transaction);
  const layer: RasterLayer = {
    ...layerDefaults(id, '背景'), // PS 拼合后的默认图层名
    kind: 'raster',
    tiles: store.tiles.handle(id),
    bounds,
  };
  store.dispatchWithPixels(createFlattenImageCommand(layer), transaction.end());
  store.setActiveLayer(id);
  return true;
}
